import React, { Component } from "react";
import { Link } from "react-router-dom";

export default class CallToAction extends Component {
  render() {
    return (
      <section className="call-to-action-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="col-to-action">
                <h4>Enjoy a GREAT travel with us</h4>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s
                </p>
                <Link to="/" className="btn btn-primary">
                  Read More
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
